import { useEffect, useState } from 'react'
import type { ImgHTMLAttributes } from 'react'
import styles from './AImage.module.less'
import cls from 'classnames'

interface Props extends ImgHTMLAttributes<HTMLImageElement> {
  src: string
  // mode?: 'default' | 'autoCalc'
}

const COMPONENT_NAME = 'A-Image'

function AImage(props: Props) {
  const { src, className, alt = '', onLoad, onError, fetchPriority, ...restProps } = props
  const [isLoaded, setIsLoaded] = useState(false)
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    setIsLoaded(false)
    setIsError(false)
  }, [src])

  const classNames = cls(
    styles[COMPONENT_NAME],
    className,
    { [styles.loaded]: isLoaded || isError }
    // { [styles.normalSize]: mode === 'default' },
    // { [styles.autoCalcSize]: mode === 'autoCalc' }
  )

  return (
    <span className={styles.imageWrapper}>
      {!isLoaded && !isError && <span className={styles.skeleton} aria-hidden='true' />}
      <img
        className={classNames}
        src={src}
        alt={alt}
        onLoad={(event) => {
          setIsLoaded(true)
          onLoad?.(event)
        }}
        onError={(event) => {
          setIsError(true)
          onError?.(event)
        }}
        {...restProps}
        {...(fetchPriority ? { fetchpriority: fetchPriority } : {})}
      />
    </span>
  )
}

export default AImage
